import { TMetaPrimitives } from '@cian/logger/shared';
import {
  fetchCreateProject,
  TCreateProjectRequest,
  TCreateProjectResponse,
} from 'shared/repositories/promotions-flow-control/v1/create-project';

import { IApplicationContext } from 'shared/types/applicationContext';

export type { TCreateProjectRequest };

export async function createProject(
  { httpApi, logger }: IApplicationContext,
  parameters: TCreateProjectRequest,
): Promise<Boolean> {
  try {
    const result: TCreateProjectResponse = await fetchCreateProject({ httpApi, parameters });

    if (result.statusCode !== 200) {
      logger.warning(result.response.message || /* istanbul ignore next */ 'Код ответа не 200', {
        domain: 'src/shared/services/createProject.ts [createProject]',
        message: 'Не удалось создать проект',
        errors: result.response.errors as unknown as TMetaPrimitives[],
      });

      return false;
    }

    return true;
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/createProject.ts [createProject]',
      message: 'Не удалось создать проект',
    });

    throw error;
  }
}
